import { createContext, useContext, useReducer } from "react";
import React from "react";
import { initialState, reducers } from "./reducers";
const ProductsAppContext = createContext();

const ProductsAppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducers, initialState);

  const name = "Isha";
  return (
    <ProductsAppContext.Provider value={{ name, state, dispatch }}>
      {children}
    </ProductsAppContext.Provider>
  );
};

const useProductsContext = () => {
  return useContext(ProductsAppContext);
};
export { ProductsAppContext, ProductsAppProvider, useProductsContext };
